/* eslint-disable no-console */
export const logger = () => {
  const log = (object, mode = 'log') => {
    if (mode === 'error') {
      console.error(object);
      // TODO: Send to server | log persistently
    }
  };

  return {
    log_request: (url, payload) => {
      log('Request URL: ' + url, payload);
    },
    log: (object, mode = 'log') => {
      log(object, mode);
    },
  };
};
